import { useState } from "react";
import { Box, Typography, TextField, Grid, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import axiosInstance from "../../../api/axios";
import {
  notifySuccess,
  notifyError,
} from "../../../components/common/toast/ToastFunc";

import contactImg from "../../../assests/images/contact.jpg";

const ContactUs = () => {
  const theme = useTheme();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [errors, setErrors] = useState({
    name: "",
    email: "",
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    let error = "";

    // Validate the name field to not include numbers
    if (name === "name" && /[\d]/.test(value)) {
      error = "Name should not contain numbers.";
      setErrors((prev) => ({ ...prev, [name]: error }));
      return; // Prevent setting form data if error in name
    } else {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }

    // Continue setting form data if no error
    setFormData({ ...formData, [name]: value });
  };

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email.toLowerCase());
  };

  const handleSubmit = async () => {
    if (!formData.name || !formData.email || !formData.message) {
      notifyError("Please fill in all fields.");
      return;
    }

    if (errors.name || (formData.email && !validateEmail(formData.email))) {
      notifyError("Please provide a valid email address.");
      return;
    }


    try {
      setLoading(true);
      const response = await axiosInstance.post("/customer/user-info/contact", formData);
      notifySuccess(response?.data?.message || "Success");
      setFormData({
        name: "",
        email: "",
        message: "",
      });
    } catch (error) {
      notifyError(error.message || "Something went wrong");
    } finally {
      setLoading(false);
    }

  };

  const textFieldTheme = {
    "& label.Mui-focused": {
      color: theme.mainColor,
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "grey",
        borderRadius: "7px",
      },
      "&:hover fieldset": {
        borderColor: theme.mainColor,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.mainColor,
      },
    },
  };

  return (
    <Grid
      container
      sx={{
        alignItems: "center",
        justifyContent: "center",
        height: "90vh",
        padding: 3,
      }}
    >
      <Grid item xs={12}>
        <Typography
          gutterBottom
          align="center"
          sx={{ fontSize: "35px", color: "#990000", fontWeight: "bold" }}
        >
          Tell us your problem!!
        </Typography>
      </Grid>
      <Box
        component="img"
        sx={{
          height: 470,
          width: 470,
          padding: 12,
          mb: 2,
        }}
        alt="Login Image"
        src={contactImg}
      />
      <Grid item xs={12} sm={8} md={6} lg={4}>
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{
            maxWidth: 500,
            p: 4,
            boxShadow: 3,
            borderRadius: 2,
          }}
        >
          <Typography
            variant="h4"
            sx={{ mb: 2, color: theme.mainColor, fontWeight: "bold" }}
          >
            Contact Us
          </Typography>
          <TextField
            fullWidth
            label="Name"
            variant="outlined"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            error={!!errors.name}
            helperText={errors.name}
            sx={{ mb: 2, ...textFieldTheme }}
          />
          <TextField
            fullWidth
            label="Email"
            variant="outlined"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleInputChange}
            sx={{ mb: 2, ...textFieldTheme }}
          />
          <TextField
            fullWidth
            label="Message"
            variant="outlined"
            name="message"
            multiline
            rows={4}
            value={formData.message}
            onChange={handleInputChange}
            sx={{ mb: 2, ...textFieldTheme }}
          />
          <Button
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            fullWidth
            disabled={loading}
            sx={{
              mt: 1,
              bgcolor: theme.mainColor,
              "&:hover": { bgcolor: "#b30000" },
            }}
          >
            Send Message
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ContactUs;
